<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'PreviewCard'
}
</script>

<style>

</style>
